/* KE cart drawer behaviours (2026-09-11). Custom elements so they re-init after Dawn swaps the drawer HTML. */
(function () {
  if (!customElements.get('ke-dispatch-timer')) {
    customElements.define('ke-dispatch-timer', class extends HTMLElement {
      connectedCallback() { this.tick(); this._t = setInterval(() => this.tick(), 1000); }
      disconnectedCallback() { clearInterval(this._t); }
      etParts() {
        const f = new Intl.DateTimeFormat('en-US', { timeZone: this.dataset.tz || 'America/New_York', hour12: false, weekday: 'short', hour: 'numeric', minute: 'numeric', second: 'numeric' });
        const p = {}; f.formatToParts(new Date()).forEach(x => (p[x.type] = x.value));
        return { wd: p.weekday, h: Number(p.hour) % 24, m: Number(p.minute), s: Number(p.second) };
      }
      tick() {
        const cutoff = Number(this.dataset.cutoff || 14); const { wd, h, m, s } = this.etParts();
        const weekday = !['Sat', 'Sun'].includes(wd);
        const secsLeft = (cutoff * 3600) - (h * 3600 + m * 60 + s);
        if (weekday && secsLeft > 0) {
          const hh = Math.floor(secsLeft / 3600), mm = Math.floor((secsLeft % 3600) / 60), ss = secsLeft % 60;
          this.innerHTML = 'Order within <span class="ke-dr-cd">' + hh + ':' + String(mm).padStart(2, '0') + ':' + String(ss).padStart(2, '0') + '</span> to ship today';
        } else if (wd === 'Fri' || wd === 'Sat' || wd === 'Sun') {
          this.textContent = 'Order now — ships Monday';
        } else {
          this.textContent = 'Order now — ships next business day';
        }
      }
    });
  }

  if (!customElements.get('ke-essential')) {
    customElements.define('ke-essential', class extends HTMLElement {
      connectedCallback() {
        const sel = this.querySelector('.ke-dr-ess-sel'), btn = this.querySelector('.ke-dr-ess-add');
        if (sel && btn) sel.addEventListener('change', () => { btn.dataset.variantId = sel.value; btn.dataset.size = sel.options[sel.selectedIndex].text; });
      }
    });
  }


  if (!customElements.get('ke-auto-slider')) {
    // Continuous glide (px/s), seamless loop by duplicating the cards. Pauses on hover/touch,
    // yields to the user's own scrolling for a few seconds, skips under reduced-motion.
    customElements.define('ke-auto-slider', class extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this._speed = Number(this.dataset.speed || 34);
        this._hold = 0; this._hover = false; this._last = null; this._raf = null;
        const hold = (ms) => { this._hold = performance.now() + ms; };
        this.addEventListener('pointerenter', () => (this._hover = true));
        this.addEventListener('pointerleave', () => (this._hover = false));
        this.addEventListener('pointerdown', () => hold(4000));
        this.addEventListener('wheel', () => hold(4000), { passive: true });
        this.addEventListener('touchstart', () => hold(4000), { passive: true });
        this.addEventListener('touchmove', () => hold(4000), { passive: true });
        this.addEventListener('touchend', () => hold(3000), { passive: true });
        requestAnimationFrame(() => this.init());
      }
      disconnectedCallback() { cancelAnimationFrame(this._raf); }
      init() {
        if (!this.isConnected || this.scrollWidth <= this.clientWidth + 4) return;
        if (!this._dup) {
          const kids = Array.from(this.children);
          this._loopW = kids.reduce((w, k) => w + k.getBoundingClientRect().width, 0) + 10 * kids.length;
          // three copies; we live in the middle one so a finger can drag left OR right at any time
          for (let n = 0; n < 2; n++) kids.forEach((k) => { const c = k.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.dataset.clone = '1'; this.appendChild(c); });
          this._dup = true;
          this.style.scrollSnapType = 'none';
          this.scrollLeft = this._loopW;
        }
        this._raf = requestAnimationFrame((t) => this.tick(t));
      }
      tick(now) {
        if (!this.isConnected) return;
        if (this._last == null) this._last = now;
        const dt = Math.min(0.05, (now - this._last) / 1000); this._last = now;
        if (!this._hover && now > this._hold) {
          // float position; scrollLeft is integer-rounded by the browser, so never accumulate on it
          if (this._pos == null || Math.abs(this._pos - this.scrollLeft) > 2) this._pos = this.scrollLeft;
          this._pos += this._speed * dt;
          // keep the window inside the middle copy (identical content, so the jump is invisible)
          if (this._pos >= 2 * this._loopW) this._pos -= this._loopW;
          if (this._pos < this._loopW) this._pos += this._loopW;
          const next = Math.round(this._pos);
          if (next !== this.scrollLeft) this.scrollLeft = next;
        } else {
          this._pos = null;
        }
        this._raf = requestAnimationFrame((t) => this.tick(t));
      }
    });
  }

  // CHECKOUT in the drawer goes straight to checkout — never via the /cart page (Tyler 2026-09-11)
  document.addEventListener('click', (e) => {
    const b = e.target && e.target.closest && e.target.closest('#CartDrawer-Checkout');
    if (!b || b.disabled) return;
    e.preventDefault();
    b.disabled = true;
    b.dataset.keNav = '1';
    // backstop: if the navigation never commits (Back/Stop before checkout loads), re-arm the button
    setTimeout(() => { if (b.isConnected && b.dataset.keNav) { b.disabled = false; delete b.dataset.keNav; } }, 8000);
    window.location.href = '/checkout';
  });

  // History navigation can restore stale cart HTML even without a persisted bfcache page.
  // Read both sections together; never replay an add/remove or force a page reload.
  let historyCartGeneration = 0;
  let historyCartRefreshNeeded = false;
  let historyCartController;
  const historyCartMutations = new Set();

  document.addEventListener('ke:cart-mutation', (e) => {
    const { phase, id } = e.detail || {};
    if (!id || (phase !== 'start' && phase !== 'end')) return;
    historyCartGeneration++;
    if (phase === 'start') {
      historyCartMutations.add(id);
      historyCartController?.abort();
    } else {
      historyCartMutations.delete(id);
      if (historyCartRefreshNeeded && !historyCartMutations.size) refreshCartAfterHistory();
    }
  });

  function refreshCartAfterHistory() {
    if (!historyCartRefreshNeeded || historyCartMutations.size) return;
    const drawer = document.querySelector('cart-drawer');
    const inner = drawer?.querySelector('.drawer__inner');
    const bubble = document.getElementById('cart-icon-bubble');
    if (!drawer || !inner || !bubble) return;
    const lines = drawer.querySelector('cart-drawer-items');
    const generation = ++historyCartGeneration;
    historyCartController?.abort();
    const controller = new AbortController();
    historyCartController = controller;
    const timeout = setTimeout(() => controller.abort(), 8000);

    fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`, {
      credentials: 'same-origin', cache: 'no-store', signal: controller.signal
    })
      .then((response) => {
        if (!response.ok) throw new Error('Cart history refresh failed');
        return response.json();
      })
      .then((sections) => {
        // A newer mutation/read owns the cart. Its completion retries this history read if needed.
        if (generation !== historyCartGeneration || historyCartMutations.size) return;
        if (!drawer.isConnected || drawer.querySelector('.drawer__inner') !== inner ||
            drawer.querySelector('cart-drawer-items') !== lines) {
          historyCartRefreshNeeded = false; // another renderer has already replaced the cart
          return;
        }
        // A section can be null in an otherwise successful Shopify response. Keep BOTH old views
        // unless both replacement sections are valid, so the drawer and badge cannot disagree.
        if (typeof sections?.['cart-drawer'] !== 'string' || typeof sections?.['cart-icon-bubble'] !== 'string') {
          throw new Error('Cart history sections unavailable');
        }
        const parser = new DOMParser();
        const freshDrawer = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('cart-drawer');
        const freshInner = freshDrawer?.querySelector('.drawer__inner');
        const freshBubble = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (!freshInner || !freshBubble) throw new Error('Cart history sections incomplete');
        drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
        inner.innerHTML = freshInner.innerHTML;
        bubble.innerHTML = freshBubble.innerHTML;
        historyCartRefreshNeeded = false;
        // Keep a closed drawer closed; restore the focus trap only if it is already open.
        if (drawer.classList.contains('active') && typeof trapFocus === 'function') trapFocus(inner, inner);
      })
      .catch((error) => {
        if (generation !== historyCartGeneration) return;
        historyCartRefreshNeeded = false;
        console.warn('Cart could not be refreshed after history navigation.', error);
      })
      .finally(() => {
        clearTimeout(timeout);
        if (historyCartController === controller) historyCartController = undefined;
      });
  }

  window.addEventListener('pageshow', (e) => {
    const navigation = performance.getEntriesByType?.('navigation')[0];
    if (!e.persisted && navigation?.type !== 'back_forward') return;
    // Re-arm only the checkout button this script disabled, not a deliberately empty-cart button.
    document.querySelectorAll('#CartDrawer-Checkout[data-ke-nav]').forEach((b) => {
      b.disabled = false;
      delete b.dataset.keNav;
    });
    historyCartRefreshNeeded = true;
    refreshCartAfterHistory();
  });

  // close on overlay tap after Dawn re-renders (#CartDrawer innerHTML swap drops the listener)
  document.addEventListener('click', (e) => {
    if (e.target && e.target.id === 'CartDrawer-Overlay') document.querySelector('cart-drawer')?.close?.();
  });
})();
